import { useTheme, useMediaQuery } from '@mui/material';
const useMediaQueries = () => {
    const theme = useTheme();
    const fitForDesktop = useMediaQuery(theme.breakpoints.up('desktop'));
    const fitForTablet = useMediaQuery(theme.breakpoints.between('sm', 'desktop'));
    const fitForMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const conditions = [
        [fitForDesktop, 'desktop'],
        [fitForTablet, 'tablet'],
        [fitForMobile, 'mobile'],
    ];
    const mediaClassNames = conditions.reduce((acc, [condition, className]) => {
        if (condition)
            acc.push(className);
        return acc;
    }, []);
    return {
        fitForDesktop,
        fitForTablet,
        fitForMobile,
        mediaClassNames: mediaClassNames.join(' '),
    };
};
export default useMediaQueries;
//# sourceMappingURL=useMediaQueries.js.map